import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonLayout } from "../cta-button-layout";
import { CtaButtonLayoutSubtitleNotePriceContext } from "./cta-button-layout-subtitle-note-price.models";
import { PriceSettings } from "@dodo/price-display/price-display.model";

@Component({
    selector: "dodo-cta-button-layout-subtitle-note-price",
    templateUrl: "./cta-button-layout-subtitle-note-price.component.html",
    styleUrls: ["./cta-button-layout-subtitle-note-price.component.scss"],
    standalone: false
})
export class CtaButtonLayoutSubtitleNotePriceComponent extends CTAButtonLayout
	implements OnInit {
	@Input() subtitle: string;
	@Input() subtitleNote: string;
	@Input() price: number;
	@Input() priceText: string;
	@Input() beforePriceText: string;
	@Input() afterPriceText: string;
	@Input() displayZeroPrice: boolean;
	@Input() displaySign: boolean;

	_settings = <PriceSettings>{};

	@Input() set context(ctx: CtaButtonLayoutSubtitleNotePriceContext) {
		this.subtitle = ctx.subtitle;
		this.subtitleNote = ctx.subtitleNote;
		this.price = ctx.price;
		this.priceText = ctx.priceText;
		this.beforePriceText = ctx.beforePriceText;
		this.afterPriceText = ctx.afterPriceText;
		this.displayZeroPrice = ctx.displayZeroPrice;
		this.displaySign = ctx.displaySign;
		this._settings.displaySign = this.displaySign;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
